module.exports = __webpack_public_path__ + "static/media/crossRed.13b57063.svg";